/** @jsxImportSource @emotion/react */
import { useMemo } from "react";
import TableWithSkeleton from "tables/common/TableWithSkeleton";
import PropTypes from "prop-types";
import useDeleteScheduledReportMutation from "hookMutation/useDeleteScheduledReportMutation";
import useDuplicateScheduledReportMutation from "hookMutation/useDuplicateScheduledReportMutation";
import useColumns from "./useColumns";

export default function ScheduledReportsTable({ reports, isLoading, onEdit }) {
  const deleteScheduledReportMutation = useDeleteScheduledReportMutation();
  const duplicateScheduledReportMutation = useDuplicateScheduledReportMutation();
  const columns = useColumns();
  const meta = useMemo(
    () => ({
      onEdit,
      deleteScheduledReport: deleteScheduledReportMutation.mutate,
      duplicateScheduledReport: duplicateScheduledReportMutation.mutate,
    }),
    [onEdit, deleteScheduledReportMutation.mutate, duplicateScheduledReportMutation.mutate],
  );

  return (
    <TableWithSkeleton
      data={reports ?? []}
      columns={columns}
      isLoading={isLoading}
      isFetching={deleteScheduledReportMutation.isLoading}
      getRowId={(row) => row.id}
      meta={meta}
    />
  );
}

ScheduledReportsTable.propTypes = {
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape({})),
};
